TagalysCustomisations = {};

const getCardMarkup = (
  html,
  helpers,
  product,
  context,
  sizesStr = '(min-width: 990px) 25vw, calc((100vw - 48px) / 2)',
  cardModClasses,
  enableMobileQuickAdd = true
) => {

  // loyality locked product logic start
  let isLockedProduct = false;
  let iscustomereligible = false;
  let iscustomerLoggedIn = false;
  let prioritizedTiers = ["bronze","silver","gold","platinum"];
  let prodTier = "";
  let customerTier = "";
  let prodTiersIndex = 0;
  let customerTierIndex = 0;

  let productTierTags = product.tags.filter(tag => tag.toLowerCase().includes("exclusive:"));
  let productTierTagsStr = productTierTags.join();

  for(let i = 0; i <= prioritizedTiers.length; i++){
    if(productTierTagsStr.toLowerCase().includes(prioritizedTiers[i])){
        isLockedProduct = true;
        prodTier = prioritizedTiers[i];
        prodTiersIndex = i + 1;
        break;
    }
  }

  if(window.customer.isLoggedIn){
      iscustomerLoggedIn = true;
      let customerTierTags = window.customer.tags.filter(tag => tag.includes("tier"));
      if(customerTierTags.length > 0) {
        customerTier = customerTierTags[0].split("tier:")[1].trim().toLowerCase();
      }

      for(let i = 0; i <= prioritizedTiers.length; i++){
        if(customerTier == prioritizedTiers[i]){
            customerTierIndex = i + 1;
            break;
        }
      }

      if (customerTierIndex >= prodTiersIndex){
        iscustomereligible = true;
      }
  }
  
  // loyality locked product logic end

  const randomId = Math.round(Math.random() * 1000000); // used to ID modal & opener

  const price = helpers.getPrice(product);
  const compareAtPrice = helpers.getCompareAtPrice(product);

  const sizeVariants = product.variants?.filter((x) => x.option1 !== null);
  const title_arr = product.title.split(' ');
  const title_line_main = title_arr[0];
  const title_line_second = title_arr.slice(1).join(' ');
  const secondaryImg = product.images && product.images.length > 1 ? product.images[product.images.length - 1] : null;

  // used for initial swatch active state
  let cardColor = product.title.split(' - ')[product.title.split(' - ').length - 1];
  cardColor = cardColor.replaceAll(' ', '-');
  cardColor = cardColor.replaceAll('--', '-');
  cardColor = cardColor.replaceAll('---', '-');
  cardColor = cardColor.replaceAll('/', '-');
  const cardColorHandle = cardColor.toLowerCase().trim();

  let colorVariants = product.__tagalys_fields?.stitched_products;
  if (colorVariants && colorVariants.length) {
    colorVariants = colorVariants.filter((variant) => {
      return variant.metafields.filter?.colour?.value[0];
    });
  }

  const discountSettingsArray = window.theme && window.theme.discount_messaging ? window.theme.discount_messaging : null;
  const productTags = product.tags || [];
  let discountPrice;
  let discountSettings;
  let beforeDiscount;
  let afterDiscount;

  for(let i = 0; i < discountSettingsArray.length; i++) {
    if(discountSettingsArray[i].enable) {
      const discountValue = productTags.includes(discountSettingsArray[i]?.tag) && price != null ? (100 - discountSettingsArray[i].value) * 0.01 : null;
      discountPrice = productTags.includes(discountSettingsArray[i]?.tag) && price != null ? helpers.formatCurrency((price * discountValue).toFixed(2)) : null;
      if(discountPrice) {
        discountSettings = discountSettingsArray[i];
        const content = discountSettings.content || ''; // Fallback to an empty string if content is undefined
        const splitContent = content.split('[discount]');

        beforeDiscount = splitContent[0] || ''; // Handle cases where content is empty
        afterDiscount = splitContent[1] || '';  // Handle cases where there's nothing after [discount]
      }
    }
  }

  product.price = price;
  product.compare_at_price = compareAtPrice;
  const badgeText = window.Shopify.theme.helpers.getBadgeString(product, undefined, 'background-1');

  const productData = {
    color: cardColor,
    id: product.id,
    handle: product.handle,
    title: product.title,
    vendor: product.vendor,
    type: product.type,
    first_variant: {
      id: product.variants[0].id,
      sku: product.variants[0].sku,
      price: product.variants[0].price,
    },
  };

  const moneyPrice = helpers.formatCurrency(price);
  const moneyCompareAtPrice = helpers.formatCurrency(compareAtPrice);

  const data = {
    sizeVariants,
    productLink: product.__tagalys_fields.link,
    moneyCompareAtPrice,
    moneyPrice,
    isSoldOut: !product.available,
    isOnSale: helpers.isProductOnSale(compareAtPrice, price),
    titleLine1: title_line_main,
    titleLine2: title_line_second,
  };

  const mobileQuickAddMarkup = enableMobileQuickAdd
    ? window.Shopify.theme.helpers.getMobileQuickAddMarkup(data, context, html)
    : ``;

  // prettier-ignore-start
  return html`
    <product-card
      context="${context}"
      class="card-wrapper product-card-wrapper${discountPrice ? ' discount-message' : ``}${enableMobileQuickAdd
        ? ` mobile-quick-add`
        : ``}"
      product-data="${JSON.stringify(productData)}"
    >
      <div
        class="card card--standard card--media card--compact-small ${cardModClasses ? cardModClasses : ``}"
        style="--ratio-percent: ${(1 / window.themeSettings.cardImageRatio) * 100}%;"
      >
        <div class="card__inner color-background-2 gradient ratio">
          <div class="card__media">
            <div class="media media--transparent media--hover-effect">
              <card-media-carousel>
                <ul class="card__media-carousel js-carousel-list">
                  ${product.media.slice(0, -1).map((currentMedia, index) => {
                    let isVideo = false;
                    let currentVideoSources = [];

                    if (currentMedia.media_type === 'video') {
                      isVideo = true;

                      currentMedia.sources?.forEach((source) => {
                        const existingFormatIndex = currentVideoSources.findIndex(
                          (vidSource) => vidSource.format == source.format
                        );
                        if (existingFormatIndex === -1) {
                          let videoType;
                          switch (source.format.toLowerCase()) {
                            case 'mp4':
                              videoType = 'video/mp4';
                              break;
                            case 'webm':
                              videoType = 'video/webm';
                              break;
                            case 'ogg':
                              videoType = 'video/ogg';
                              break;
                            case 'm3u8':
                              videoType = 'application/x-mpegURL';
                              break;
                            default:
                          }
                          currentVideoSources.push({
                            format: source.format,
                            url: source.url,
                            type: videoType,
                          });
                        }
                      });
                    }

                    return html`<li class="card__media-slide${index === 0 ? ' card__media-slide--active' : ''}">
                      ${isVideo
                        ? html`<video
                            width="1365"
                            height="2048"
                            class="media__tag"
                            playsinline="playsinline"
                            autoplay="autoplay"
                            muted="muted"
                            loop="loop"
                          >
                            ${currentVideoSources.map(
                              (vidSource) => html`<source
                                data-src="${vidSource.url}"
                                type="${vidSource.type}"
                                src="${vidSource.url}">
                              </source>`
                            )}
                            Sorry, your browser doesn't support embedded videos.
                          </video>`
                        : html`<img
                            srcset="
                              ${currentMedia.src}&width=165   165w,
                              ${currentMedia.src}&width=360   360w,
                              ${currentMedia.src}&width=533   533w,
                              ${currentMedia.src}&width=720   720w,
                              ${currentMedia.src}&width=940   940w,
                              ${currentMedia.src}&width=1066 1066w
                            "
                            src="${currentMedia.src}"
                            sizes="${sizesStr}"
                            alt="${product.title}"
                            class="motion-reduce media__tag"
                            loading="lazy"
                            width="1365"
                            height="2048"
                          />`}
                      ${index === 0 &&
                      html`<img
                        srcset="
                          ${secondaryImg.src}&width=165   165w,
                          ${secondaryImg.src}&width=360   360w,
                          ${secondaryImg.src}&width=533   533w,
                          ${secondaryImg.src}&width=720   720w,
                          ${secondaryImg.src}&width=940   940w,
                          ${secondaryImg.src}&width=1066 1066w
                        "
                        src="${secondaryImg.src}"
                        sizes="${sizesStr}"
                        alt="${product.title}"
                        class="card__media-ghost-image motion-reduce media__tag"
                        loading="lazy"
                        width="1365"
                        height="2048"
                      />`}
                    </li>`;
                  })}
                </ul>
              </card-media-carousel>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <div class="card-information-top">
                <p class="h4 card__heading">
                  <a href="${product.__tagalys_fields.link}"
                    >${title_line_main} <span class="visually-hidden">${title_line_main}</span></a
                  >
                </p>
                <div class="card_under-heading">
                  <p class="card__subheading">${title_line_second}</p>
                </div>
              </div>
            </div>
            ${badgeText
              ? html`<div class="card__badge top left">
                  <span
                    class="badge badge--bottom-left color-background-1${badgeText.toLowerCase().trim() === 'final sale'
                      ? ' badge--final-sale'
                      : ''}"
                    >${badgeText}</span
                  >
                </div>`
              : ``}
          </div>
        </div>
        ${product.media.length > 1 &&
        html`
          <div
            class="card__carousel-buttons"
            style="--ratio-percent: ${(1 / window.themeSettings.cardImageRatio) * 100}%;"
          >
            <button class="card__carousel-button js-carousel-prev">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                aria-hidden="true"
                focusable="false"
                class="icon icon-arrow"
                viewBox="0 0 17 18"
              >
                <g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="m8 16 8-8-8-8M16 8H0" /></g>
              </svg>
            </button>
            <button class="card__carousel-button js-carousel-next">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                aria-hidden="true"
                focusable="false"
                class="icon icon-arrow"
                viewBox="0 0 17 18"
              >
                <g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="m8 16 8-8-8-8M16 8H0" /></g>
              </svg>
            </button>
          </div>
        `}
        <div class="card__content">
          <div class="quick-add no-js-hidden">
            ${isLockedProduct && !iscustomereligible ? html`
                  <div class="exclusive__msg__bar exclusive_tier_${prodTiersIndex} color-background-2">
                      <svg aria-label="padlock icon" class="icon icon-padlock" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M18.44,23.68H5.56a1.89,1.89,0,0,1-1.89-1.89v-8.4A1.89,1.89,0,0,1,5.56,11.5H18.44a1.89,1.89,0,0,1,1.89,1.89v8.4A1.89,1.89,0,0,1,18.44,23.68ZM5.56,12.5a.89.89,0,0,0-.89.89v8.4a.89.89,0,0,0,.89.89H18.44a.89.89,0,0,0,.89-.89v-8.4a.89.89,0,0,0-.89-.89Z"></path><path fill="currentColor" d="M17.59,12.5a.5.5,0,0,1-.5-.5V6.41a5.09,5.09,0,0,0-10.18,0V12a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V6.41a6.09,6.09,0,0,1,12.18,0V12A.5.5,0,0,1,17.59,12.5Z"></path><path fill="currentColor" d="M12.09,20.4h-.18a1.12,1.12,0,0,1-1.12-1.12V17.83a2,2,0,1,1,2.42,0v1.45A1.12,1.12,0,0,1,12.09,20.4ZM12,15.27a1,1,0,0,0-.47,1.85.51.51,0,0,1,.26.44v1.72a.13.13,0,0,0,.12.12h.18a.13.13,0,0,0,.12-.12V17.56a.51.51,0,0,1,.26-.44,1,1,0,0,0,.52-.86A1,1,0,0,0,12,15.27Z"></path></svg>
                      <p>Exclusive Product. <a href="/pages/m-list">Learn More</a></p>
                  </div>
              ` : 
              html`<ul class="quick-add__variants-atcs scrollbar-hide">
              ${sizeVariants.map(
                (variant) =>
                  html`
                    <li>
                      <quick-buy variant-ids="${variant.id}">
                        ${variant.available ? 
                        html`<button class="button-invisible" type="button">
                          ${variant.title}
                        </button>` 
                        : html `<button disabled class="button-invisible" type="button">
                          ${variant.title}
                        </button>`
                        }
                      </quick-buy>
                    </li>
                  `
              )}
            </ul>`
            }
          </div>
          <div class="card__information">
            <div class="card-information-top">
              ${colorVariants
                ? html`
                    <div class="card__swatches-mobile">
                      <ul class="list-unstyled flex-row">
                        ${colorVariants?.map((variant) => {
                          let color = variant.name.split(' - ')[variant.name.split(' - ').length - 1];
                          color = color.replaceAll(' ', '-');
                          color = color.replaceAll('--', '-');
                          color = color.replaceAll('---', '-');
                          color = color.replaceAll('/', '-');
                          const colorHandle = color.toLowerCase().trim();
                          return html`
                            <li>
                              <a href="${variant.link}" class="color-swatch swatch-color-${colorHandle}">
                                <span class="visually-hidden">${color}</span>
                              </a>
                            </li>
                          `;
                        })}
                      </ul>
                    </div>
                  `
                : null}

              <h4 class="card__heading h6">
                <a href="${product.__tagalys_fields.link}" class="full-unstyled-link"
                  >${title_line_main} <span class="visually-hidden">${title_line_second}</span></a
                >
              </h4>
              <div class="card_under-heading">
                <p class="card__subheading">${title_line_second}</p>
                ${colorVariants
                  ? html`
                      <div class="card__swatches">
                        <ul class="color-swatches">
                          ${colorVariants?.map((variant) => {
                            let color = variant.name.split(' - ')[variant.name.split(' - ').length - 1];
                            color = color.replaceAll(' ', '-');
                            color = color.replaceAll('--', '-');
                            color = color.replaceAll('---', '-');
                            color = color.replaceAll('/', '-');
                            const colorHandle = color.toLowerCase().trim();
                            return html`
                              <li>
                                <a
                                  href="${variant.link}"
                                  class="color-swatch swatch-color-${colorHandle}${cardColorHandle === colorHandle
                                    ? ` is-active`
                                    : ``}"
                                  data-swatch-link
                                >
                                  <span class="visually-hidden">${color}</span>
                                </a>
                              </li>
                            `;
                          })}
                        </ul>
                      </div>
                    `
                  : null}
              </div>
            </div>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div
                class="price justify-end-price${helpers.isProductOnSale(compareAtPrice, price)
                  ? ' price--on-sale'
                  : ''}${!product.available ? ' price--sold-out' : ''}"
              >
                <div class="price__container">
                  ${discountPrice
                    ? html`
                        <span
                          class="discount_messaging ${discountSettings.content.includes('[discount]') ? 'active' : ''}"
                          style="font-size: ${discountSettings.font_size}px; color: ${discountSettings.color}; background-color: ${discountSettings.background}"
                        >
                          ${beforeDiscount} <span class="money">${discountSettings.content.includes('[discount]') ? discountPrice : ''}</span>${afterDiscount}
                        </span>
                      `
                    : null}
                  <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular">${moneyPrice}</span>
                  </div>
                  <div class="price__sale">
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item price-item--sale price-item--last">${moneyPrice}</span>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span>
                      <s class="price-item price-item--regular">${moneyCompareAtPrice}</s>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ${badgeText
            ? html`<div class="card__badge top left">
                <span class="badge badge--bottom-left color-background-1">${badgeText}</span>
              </div>`
            : ``}
          ${isLockedProduct && !iscustomereligible ? html`
              <div class="quick-add__mobile no-js-hidden">  
                <button
                  type="button"
                  class="m-list-exclusive-btn button button--secondary button--full-width button--small--compact button--quiet loyalty-tier-${prodTiersIndex} color-inverse"
                  disabled
                >
                  <svg aria-label="padlock icon" class="icon icon-padlock" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M18.44,23.68H5.56a1.89,1.89,0,0,1-1.89-1.89v-8.4A1.89,1.89,0,0,1,5.56,11.5H18.44a1.89,1.89,0,0,1,1.89,1.89v8.4A1.89,1.89,0,0,1,18.44,23.68ZM5.56,12.5a.89.89,0,0,0-.89.89v8.4a.89.89,0,0,0,.89.89H18.44a.89.89,0,0,0,.89-.89v-8.4a.89.89,0,0,0-.89-.89Z"></path><path fill="currentColor" d="M17.59,12.5a.5.5,0,0,1-.5-.5V6.41a5.09,5.09,0,0,0-10.18,0V12a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V6.41a6.09,6.09,0,0,1,12.18,0V12A.5.5,0,0,1,17.59,12.5Z"></path><path fill="currentColor" d="M12.09,20.4h-.18a1.12,1.12,0,0,1-1.12-1.12V17.83a2,2,0,1,1,2.42,0v1.45A1.12,1.12,0,0,1,12.09,20.4ZM12,15.27a1,1,0,0,0-.47,1.85.51.51,0,0,1,.26.44v1.72a.13.13,0,0,0,.12.12h.18a.13.13,0,0,0,.12-.12V17.56a.51.51,0,0,1,.26-.44,1,1,0,0,0,.52-.86A1,1,0,0,0,12,15.27Z"></path></svg> M-List Exclusive
                </button>
              </div>
            ` : mobileQuickAddMarkup}
        </div>
      </div>
    </product-card>
  `;
  // prettier-ignore-end
};

TagalysCustomisations.initSearchSuggestions = function () {
  Tagalys.UIWidgets.SearchSuggestions.init('[data-search-input]', {
    searchResultsURL: '/search',
    templates: {
      widget: {
        options: {
          selector: '#HeaderSearchMenu .search-suggestions-container',
          position: false,
          hierarchySeparator: '',
          includeTagalysCSS: false,
          request: { products: { limit: 4 }, collections: { limit: 6 } },
          minimumCharactersToShowSuggestions: 1,
          maxRecentSearchesCount: 0,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var width = helpers.getTargetNodeWidth();
          var style = props.inheritAlignmentElementWidth ? { width: width } : {};

          return html`
            <div ref=${props.tagalysSearchSuggestionsPopoverRef} style=${style} class="search-suggestions">
              ${helpers.exceedsMinimumCharactersToShowSuggestions()
                ? html` <${args.templates.typeSuggestions} /> `
                : html` <${args.templates.clickSuggestions} /> `}
            </div>
          `;
        },
      },
      typeSuggestions: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var textSuggestions = helpers.getTextSuggestions();
          var classes = ['type-suggestions'];
          if (helpers.hasTextSearchSuggestions() > 0) {
            classes.push('product-and-text-suggestions');
          } else {
            classes.push('product-suggestions');
          }
          var className = classes.join(' ');

          return html` <div class=${className}>
              ${helpers.hasTextSearchSuggestions()
                ? html`
                    <ul class="text-suggestions list-unstyled">
                      ${textSuggestions.map(
                        (textSuggestionSection) =>
                          html`
                            <${args.templates.textSuggestionSection} textSuggestionSection=${textSuggestionSection} />
                          `
                      )}
                    </ul>
                  `
                : null}
              <${args.templates.products} class="product-suggestions" />
            </div>
            <div class="search-modal__full-bleed">
              <button type="submit" class="button button--secondary button--secondary-alt button--full-width">
                View all results
              </button>
            </div>`;
        },
      },
      textSuggestionSection: {
        render: function (html, args) {
          var props = args.props;
          var textSuggestionSection = props.textSuggestionSection;

          return html`
            <li class="text-suggestion-section" data-section-id=${textSuggestionSection.section_id}>
              <div class="section-title link-label">${textSuggestionSection.section_title}</div>
              <ul class="list-unstyled">
                ${textSuggestionSection.items.map(function (textSuggestionSectionItem) {
                  return html`
                    <${args.templates.textSuggestionSectionItem}
                      textSuggestionSectionId=${textSuggestionSection.section_id}
                      textSuggestionSectionItem=${textSuggestionSectionItem}
                    />
                  `;
                })}
              </ul>
            </li>
          `;
        },
      },
      textSuggestionSectionItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var enteredSearchQuery = helpers.getEnteredSearchQuery();
          var textSuggestionSectionItem = props.textSuggestionSectionItem;
          var url = textSuggestionSectionItem.hasOwnProperty('link')
            ? textSuggestionSectionItem.link
            : props.helpers.getLink(textSuggestionSectionItem.queryString);
          return html`
            <li>
              <a class="search-results-link link-button link-button--light" href=${url}>
                <${args.templates.highlighter}
                  label=${textSuggestionSectionItem.displayString}
                  highlight=${enteredSearchQuery}
                />
              </a>
            </li>
          `;
        },
      },
      clickSuggestions: {
        render: function (html, args) {
          var helpers = args.props.helpers;
          var recentAndPopularSearches = helpers.getRecentAndPopularSearches();

          return html`
            <p class="medium-hide large-up-hide caption-bold mb-s4">Top Searches</p>
            <div class="scrollbar-x-fade-indicator">
              <ul class="click-suggestions list-unstyled flex-row no-wrap gap-s4 scrollbar-hide scrollbar--x-only">
                <li class="small-hide">
                  <span class="link-label">Top Searches</span>
                </li>
                ${recentAndPopularSearches.recentSearches.map(
                  (recentSearch) => html` <${args.templates.recentSearchItem} recentSearch=${recentSearch} /> `
                )}
                ${recentAndPopularSearches.popularSearches.map(
                  (popularSearch) => html` <${args.templates.popularSearchItem} popularSearch=${popularSearch} /> `
                )}
              </ul>
            </div>
          `;
        },
      },
      products: {
        render: function (html, args) {
          var props = args.props;
          var products = props.helpers.getProducts();
          return html`
            <div class="search-modal__full-bleed--small">
              <div class=${`products scrollbar scrollbar-hide ${props.className}`}>
                ${products.map((product, index) => {
                  return html` <${args.templates.product} key=${product.id} product=${product} /> `;
                })}
              </div>
            </div>
          `;
        },
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var product = props.product;
          return html` <div>
            ${getCardMarkup(
              html,
              helpers,
              product,
              'search-suggestions',
              '(min-width: 750px) 18vw, calc(50vw - 32px)',
              'card--compact',
              false
            )}
          </div>`;
        },
      },
      popularSearchItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var enteredSearchQuery = helpers.getEnteredSearchQuery();
          return html`
            <li class="click-suggestion popular-search-item">
              <a
                class="search-results-link link-button text-no-wrap"
                href=${helpers.getLink(props.popularSearch.queryString)}
              >
                <${args.templates.highlighter}
                  label=${props.popularSearch.displayString}
                  highlight=${enteredSearchQuery}
                />
              </a>
            </li>
          `;
        },
      },
    },
    callbacks: {},
  });
};

TagalysCustomisations.initSearchResults = function () {
  Tagalys.UIWidgets.SearchResults.init('[data-search-results]', {
    templates: {
      filters: {
        options: {
          collapsible: true,
          includeSortOptionsInFilters: false,
          autoCollapse: true,
          showAppliedFilters: true,
          showClearAllFilters: true,
          showClearActionForIndividualFilters: true,
          showMatchingProductsCount: true,
          defaultExpandedFilters: [],
          showFiltersInDrawer: () => {
            return window.innerWidth <= 768;
          },
        },
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;
  
          var filters = helpers.getFilters();
          var appliedFilters = helpers.getAppliedFilters(true);
          var showClearAllFiltersAction =
            props.showClearAllFilters && appliedFilters.length;
          var classes = ["filters"];
          if (props.collapsible) {
            classes.push("collapsible");
          }
  
          var className = classes.join(" ");
          return html`
            <facet-filters-form>
              
              ${props.showAppliedFilters && false
                ? html` <${args.templates.appliedFilters} /> `
                : null}
              ${showClearAllFiltersAction && false
                ? html`
                    <div
                      class="clear-all-filters"
                      onclick=${helpers.clearAllFilters}
                    >
                      ${labels.filters.clearAllFilters}
                    </div>
                  `
                : null}
              ${props.includeSortOptionsInFilters === "top" && false
                ? html` <${args.templates.sortOptionInFilters} /> `
                : null}
              <form id="FacetFiltersFormMobile" class="mobile-facets">
                <div class="mobile-facets__inner search-mobile-facets__inner gradient">
                <div class="mobile-facets__header">
              <div class="mobile-facets__header-inner">
                <button class="button button--tertiary small-hide" type="button" onClick=${props.helpers.closeFilterDrawer} >
                  <span><span hover-inherit="" class="mask-text scroll-trigger scroll-trigger--offscreen" aria-label="Close" style="--animation-delay: 0; --animation-order: 0;">
                    <span>
                      <span class="mask-text__mask">
                        <span>Close</span>
                        <span>Close</span>
                      </span>
                    </span>
                  </span></span>
                                  </button>
                  <span class="medium-hide large-up-hide"></span>
                                  <button class="h6 ctrl-unstyled medium-hide large-up-hide gap-s2 flex-row center" onClick=${props.helpers.closeFilterDrawer} type="button" >
                                    Filter
                                    
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10" viewBox="0 0 8 10" fill="none">
                    <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>
                  </svg>

                                  </button>
                <button
                  class="button button--tertiary mobile-facets--close medium-hide large-up-hide"
                  type="button"
                  onClick=${props.helpers.closeFilterDrawer}
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      class="icon icon-close"
                      fill="none"
                      viewBox="0 0 18 17"
                    >
                      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                    </svg>
                  </span>
                </button>
                                  <p class="mobile-facets__heading medium-hide large-up-hide visually-hidden">Filter</p>
                                  <p class="mobile-facets__heading small-hide visually-hidden">Filter</p>
              </div>
            </div>
                  <div class="mobile-facets__main has-submenu gradient scrollbar">
                    ${filters.map(
                      (filter) => html`<${args.templates.filter} filter=${filter} />`
                    )}
                  </div>
                </div>
              </form>
              ${props.includeSortOptionsInFilters === true ||
              props.includeSortOptionsInFilters === "bottom"
                ? html` <${args.templates.sortOptionInFilters} /> `
                : null}
            </facet-filters-form>
          `;
        },
      },
      filtersHeader: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          return html`
            <div class="filters-header">
              <h2 class="filters-heading">${labels.filters.heading}</h2>
              <${args.templates.closeIcon} onClick=${props.helpers.closeFilterDrawer} />
            </div>
          `;
        }
      },
      filterHeader: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers
          var labels = args.labels
          var filterOptions = helpers.getTemplateOptions("filters")
          var showClearActionForIndividualFilters = (filterOptions.showClearActionForIndividualFilters && helpers.isFilterApplied(props.filterId))
          var toggleCollapsibleFilter = () => {
            helpers.toggleCollapsibleFilter(props.filterId);
          };
          var clearFilter = (event) => {
            event.stopPropagation();
            helpers.clearFilter(props.filterId);
          };
          return html`
            <summary
              class="filter-header"
            >
              <div class="summary__title">
                <p class="filter-heading ui-standard accordion__title">
                  <span hover-inherit class="mask-text scroll-trigger scroll-trigger--onscreen">
                    <span>
                      <span class="mask-text__mask">
                        <span>${props.filterHeading}</span>
                        <span>${props.filterHeading}</span>
                      </span>
                    </span>
                  </span>
                </p>
              </div>
              <${args.templates.plusArrow} />
              <${args.templates.minusArrow} />
              ${false ? html`<div class="filter-actions">
                ${showClearActionForIndividualFilters
                  ? html`
                      <div onClick=${clearFilter} class="filter-action-clear">
                        ${labels.filters.clearIndividualFilter}
                      </div>
                    `
                  : null}
                <span class="filter-action-toggle-collapse">
                  ${filterOptions.collapsible
                    ? html`
                        <${args.templates.minusArrow} />
                      `
                    : null}
                </span>
              </div>` : null}
            </summary>
          `;
        }
      },
      appliedFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
  
          var appliedFilters = helpers.getAppliedFilters(true);
          if (!appliedFilters.length) return null;
          return html`
            <ul class="applied-filters">
              ${appliedFilters.map((appliedFilter) => {
                if (appliedFilter.type === "range") {
                  return html`
                    <li
                      onClick=${() => helpers.clearFilter(appliedFilter.id)}
                      class="applied-filter"
                    >
                      <span class="applied-filter-label">
                        ${helpers.labelFormatter(
                          appliedFilter.display_format,
                          appliedFilter.selected_min,
                          appliedFilter.currency
                        )}
                        -
                        ${helpers.labelFormatter(
                          appliedFilter.display_format,
                          appliedFilter.selected_max,
                          appliedFilter.currency
                        )}
                      </span>
                      <span class="applied-filter-action-clear">
                        <${args.templates.closeIcon} />
                      </span>
                    </li>
                  `;
                }
                return appliedFilter.items.map((filterItem) => {
                  return html`
                    <li
                      class="applied-filter"
                      onClick=${() =>
                        helpers.clearFilter(appliedFilter.id, filterItem.id)}
                    >
                      <span class="applied-filter-label">
                        ${filterItem.name}
                      </span>
                      <span class="applied-filter-action-clear">
                        <${args.templates.closeIcon} />
                      </span>
                    </li>
                  `;
                });
              })}
            </ul>
          `;
        },
      },
      sortOptionInFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
  
          var filterOptions = helpers.getTemplateOptions("filters");
          var appliedSortOption = helpers.getAppliedSortOption();
          var sortOptions = helpers.getSortOptions();
  
          let classes = ["filter"];
          let isCollapseOpen = false;
          if (filterOptions.collapsible) {
            isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
            isCollapseOpen ? classes.push("expanded") : classes.push("collapsed");
          }
          var className = classes.join(" ");
  
          return html`
            <div data-filter-id="sort_options" class=${className}>
              <${args.templates.filterHeader}
                filterHeading=${labels.sortOptions.sortBy}
                filterId=${"sort_options"}
              />
              <div class="filter-body filter-body-checkboxes">
                <ul class="filter-checkboxes">
                  ${sortOptions.map((sortOption) => {
                    const checked = sortOption.id === appliedSortOption.id;
                    return html`
                      <li
                        class="filter-item"
                        data-filter-item-id=${sortOption.id}
                        onClick=${() => helpers.applySortOption(sortOption.id)}
                      >
                        <span class="filter-checkbox-and-label">
                          <input
                            class="checkbox"
                            checked=${checked}
                            type="checkbox"
                          />
                          <span class="filter-item-label-and-count">
                            <span class="filter-item-label">${sortOption.label}</span>
                          </span>
                        </span>
                      </li>
                    `;
                  })}
                </ul>
              </div>
            </div>
          `;
        },
      },
      filter: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers
          var classes = ["filter accordion mobile-facets__summary"]
          var isCollapseOpen = false
          if(props.collapsible){
            isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
            isCollapseOpen ? classes.push("expanded") : classes.push("collapsed");
          }
          var className = classes.join(" ")
          return html`
            <div class=${className} data-filter-id=${props.filter.id}>
              <details>
                <${args.templates.filterHeader}
                  filterHeading=${props.filter.name}
                  filterId=${props.filter.id}
                />
                <${args.templates.filterItems}
                  filter=${props.filter}
                />
              </details>
            </div>
          `;
        }
      },
      filterItems: {
        render: function (html, args) {
          var props = args.props;
          if (props.filter.type === "checkbox") {
            return html`
              <div class="filter-body filter-body-checkboxes accordion__content">
                <${args.templates.filterCheckBoxes}
                  filterId=${props.filter.id}
                  filterItems=${props.filter.items}
                />
              </div>
            `;
          }
          return html`
            <div class="filter-body filter-body-range">
              <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
            </div>
          `
        },
      },
      filterCheckBoxes: {
        render: function (html, args) {
          var props = args.props;
          return html`
            <div class="accordion__content--inner">
              <ul class="filter-checkboxes mobile-facets__list list-unstyled" role="list">
                ${props.filterItems.map(filterItem => {
                  return html`
                    <${args.templates.checkboxFilterItem}
                      filterId=${props.filterId}
                      filterItem=${filterItem}
                    >
                    ${filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : null
                    }
                  </${args.templates.checkboxFilterItem}>
                `;
                })}
              </ul>
            </div>
          `;
        }
      },
      checkboxFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
  
          const onFilterClick = (event) => {
            event.stopPropagation();
            if (props.filterItem.selected) {
              helpers.clearFilter(props.filterId, props.filterItem.id);
            } else {
              helpers.applyFilter(props.filterId, props.filterItem.id);
            }
          };
  
          return html`
            <li
              class="filter-item mobile-facets__item list-menu__item list-menu__item--lc"
              data-filter-item-id=${props.filterItem.id}
              onClick=${onFilterClick}
            >
              <label class="mobile-facets__label" for="input_${props.filterItem.id}">
                  ${false ? html`<span class="filter-checkbox-and-label">`:null}
                    <input
                      class="checkbox mobile-facets__checkbox"
                      ${props.filterItem.selected ? html`checked` : null}
                      type="checkbox"
                      id="input_${props.filterItem.id}"
                    />
                    <span class="mobile-facets__highlight"></span>
                    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                          <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
                                        </svg>
                    <svg class="icon icon-checkmark" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect width="16" height="16" fill="#232323"></rect>
                                          <path d="M4.14697 9.00531L7.05404 10.9644L11.647 4.00535" stroke="#FAFAEF" stroke-width="1.5"></path>
                                        </svg>
                    <span aria-hidden="true">${props.filterItem.name} (${props.filterItem.count})</span>
                    <span class="visually-hidden">${props.filterItem.name} (${props.filterItem.count})</span>

                    ${false ? html`<span class="filter-item-label-and-count">
                      <span class="filter-item-label">${props.filterItem.name}</span>
                      ${props.showMatchingProductsCount
                        ? html`
                            <span class="filter-item-count">${props.filterItem.count}</span>
                          `
                        : null}
                    </span>
                  </span>
                  ${props.children}` : null}
              </label>
            </li>
          `;
        },
      },
      rangeSliderFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels
  
          return html`
            <div class="range-slider filter-item">
              <div ref=${props.sliderRef} />
              <div class="input-group">
                <div class="input-container">
                  <input
                    type="number"
                    value=${props.sliderInputValues[0]}
                    onblur=${props.onInputBlur}
                    onchange=${props.onMinChange}
                  />
                  <label>
                    ${helpers.labelFormatter(
                      props.filter.display_format,
                      props.filter.min,
                      props.filter.currency
                    )}
                  </label>
                </div>
                <span class="to">${labels.filters.rangeFilterValueSeparator}</span>
                <div class="input-container">
                  <input
                    type="number"
                    value=${props.sliderInputValues[1]}
                    onblur=${props.onInputBlur}
                    onchange=${props.onMaxChange}
                  />
                  <label>
                    ${helpers.labelFormatter(
                      props.filter.display_format,
                      props.filter.max,
                      props.filter.currency
                    )}
                  </label>
                </div>
              </div>
            </div>
          `;
        },
      },
      closeIcon: {
        render: function (html, args) {
          return html`
            <svg
              class="close-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewbox="0 0 24 24"
              
            >
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
            </svg>
          `;
        },
      },
      plusArrow: {
        render: function (html, args) {
          return html`
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus">
              <path d="M6.02465 12L6.02465 0M0 6.02507L12 6.02507" stroke="currentColor"></path>
            </svg>
          `;
        },
      },
      minusArrow: {
        render: function (html, args) {
          return html`
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" width="12" height="2" class="icon icon-minus" fill="none" viewBox="0 0 12 2">
              <path fill="none" fill-rule="evenodd" stroke="currentColor" d="M0 1.025h12"></path>
            </svg>
          `;
        },
      },
      widget: {
        options: {
          includeTagalysCSS: false,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          if (helpers.isInitialLoading()) {
            return html` <${args.templates.loader} /> `;
          }

          let classes = ['plp', 'search-results'];
          if (helpers.isFilterDrawerOpen()) {
            classes.push('filter-drawer-opened');
          }
          if (helpers.isLoading()) {
            classes.push('loading');
          }
          if (helpers.canShowFiltersInDrawer()) {
            classes.push('show-filters-in-drawer');
          }

          var className = classes.join(' ');

          if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
            return html`
              <div class="plp search-results">
                <${args.templates.noResults} />
              </div>
            `;
          }

          return html`
            <div>
              <${args.templates.header} />
              <${args.templates.productListHeader} />
              <aside class="facets-wrapper page-width" >
                <div class="facets-container facets-container-drawer facets-container-accordions scroll-trigger animate--fade-in scroll-trigger--onscreen">
                  <menu-drawer class="tagalysfilters drawer--left drawer--bottom-small mobile-facets__wrapper">
                    <details class="mobile-facets__disclosure disclosure-has-popup">
                      <summary class="mobile-facets__open-wrapper focus-offset" >
                                <span class="mobile-facets__open mobile-facets__open--no-icon"><span class="mobile-facets__open-label button-label medium-hide large-up-hide h6 gap-s2 flex-row center">Filter

                                  <svg aria-hidden="true" focusable="false" class="icon" width="8" height="10" viewBox="0 0 8 10" fill="none">
                                    <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>
                                  </svg>

                                            </span><span class="mobile-facets__open-label button-label small-hide"><span hover-inherit="" class="mask-text  scroll-trigger" aria-label="Filter" style="--animation-delay: 0; --animation-order: 0;">
                                    <span aria-hidden="">
                                      <span class="mask-text__mask">
                                        <span>Filter</span>
                                        <span>Filter</span>
                                      </span>
                                    </span>
                                  </span></span></span>
                                          <span hidden="" tabindex="0" class="hidden mobile-facets__close mobile-facets__close--no-js"><div class="global-close-button"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                                  </path></svg>
                                  </div></span>
                              </summary>
                      <${args.templates.filters}/>
                    </details>
                  </menu-drawer>
                </div>
              </aside>
              <product-grid-container data-container-id="ProductGridContainer">
                <div class="product-grid-container page-width-mobile-tablet" id="ProductGridContainer">
                  <div class="collection">
                    <div class="loading-overlay gradient"></div>
                    <${args.templates.products} />
                    <${args.templates.productListFooter} />
                    <${args.templates.footer} />
                  </div>
                </div>
              </product-grid-container>
            </div>
          `;
        },
      },
      header: {
        render: function (html, args) {
          return html` <div class="plp-header"><${args.templates.heading} /></div> `;
        },
      },
      heading: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;

          var getHeadingBasedOnAPIResponse = () => {
            if (helpers.isPartialResults()) {
              return labels.searchResults.heading.partialMatches.replace('{{searchTerm}}', helpers.getQuery());
            }

            if (helpers.isSpellingCorrectedQuery()) {
              return labels.searchResults.heading.corrected
                .replace('{{originalSearchTerm}}', helpers.getOriginalQuery())
                .replace('{{resultsCount}}', helpers.getTotalProductsCount())
                .replace('{{correctedSearchTerm}}', helpers.getQuery());
            }

            return labels.searchResults.heading.standard
              .replace('{{resultsCount}}', helpers.getTotalProductsCount())
              .replace('{{searchTerm}}', helpers.getQuery());
          };
          return html`
            <p class="plp-heading center">
              ${getHeadingBasedOnAPIResponse().replaceAll('â€™', '”').replaceAll('â€˜', '“')}
            </p>
          `;
        },
      },
      productListHeader: {
        render: function (html, args) {
          return html`
            <div class="facets-wrapper page-width">
              <div class="facets-container facets-container-drawer">
                <${args.templates.infoAndActions} />
              </div>
            </div>
          `;
        },
      },
      infoAndActions: {
        render: function (html, args) {
          var filterOptions = args.props.helpers.getTemplateOptions('filters');

          return html`
            <div class="facets-container__lhs">
              <model-toggle for="product-grid" class="display-flex button-toggle-wrap medium-hide large-up-hide">
                <button class="link-button model-toggle-button is-active button-toggle display-flex">
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="6" height="14" fill="#232323" />
                    <rect x="7" width="6" height="14" fill="#232323" />
                    <rect x="14" width="6" height="14" fill="#232323" />
                  </svg>
                </button>
                <button class="link-button model-toggle-button button-toggle display-flex">
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.8582 0C2.74156 0 2.647 0.0895429 2.647 0.2V1.42056L1.93408 3.35152C1.91483 3.40688 1.91483 3.46629 1.93408 3.52166L2.63275 5.65777L0.00811855 13.7766C-0.0277961 13.8877 0.059948 14 0.182635 14H0.902841H11.0972H11.8174C11.9401 14 12.0278 13.8877 11.9919 13.7766L9.36725 5.65777L10.0659 3.52166C10.0852 3.46629 10.0852 3.40688 10.0659 3.35152L9.35299 1.42056V0.2C9.35299 0.0895431 9.25844 0 9.1418 0H8.13079C8.01415 0 7.9196 0.0895431 7.9196 0.2V1.36116L6.69934 2.76817C6.51095 2.96586 6.26714 3.10416 6 3.16979C5.73286 3.10416 5.48904 2.96586 5.30066 2.76817L4.0804 1.36116V0.2C4.0804 0.089543 3.98585 0 3.86921 0H2.8582Z"
                      fill="#232323"
                    />
                  </svg>
                </button>
              </model-toggle>
            </div>
            <div class="facets-container__rhs">
              <model-toggle for="product-grid" class="display-flex button-toggle-wrap small-hide">
                <button class="link-button model-toggle-button is-active button-toggle display-flex">
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="6" height="14" fill="#232323" />
                    <rect x="7" width="6" height="14" fill="#232323" />
                    <rect x="14" width="6" height="14" fill="#232323" />
                  </svg>
                </button>
                <button class="link-button model-toggle-button button-toggle display-flex">
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.8582 0C2.74156 0 2.647 0.0895429 2.647 0.2V1.42056L1.93408 3.35152C1.91483 3.40688 1.91483 3.46629 1.93408 3.52166L2.63275 5.65777L0.00811855 13.7766C-0.0277961 13.8877 0.059948 14 0.182635 14H0.902841H11.0972H11.8174C11.9401 14 12.0278 13.8877 11.9919 13.7766L9.36725 5.65777L10.0659 3.52166C10.0852 3.46629 10.0852 3.40688 10.0659 3.35152L9.35299 1.42056V0.2C9.35299 0.0895431 9.25844 0 9.1418 0H8.13079C8.01415 0 7.9196 0.0895431 7.9196 0.2V1.36116L6.69934 2.76817C6.51095 2.96586 6.26714 3.10416 6 3.16979C5.73286 3.10416 5.48904 2.96586 5.30066 2.76817L4.0804 1.36116V0.2C4.0804 0.089543 3.98585 0 3.86921 0H2.8582Z"
                      fill="#232323"
                    />
                  </svg>
                </button>
              </model-toggle>
            
              ${filterOptions.includeSortOptionsInFilters ? null : html` <${args.templates.sortOptions} /> `}
            </div>
          `;
        },
      },
      sortOptions: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;
          var sortOptions = helpers.getSortOptions();
          var appliedSortOption = helpers.getAppliedSortOption();

          var applySortOption = (event) => {
            event.preventDefault();
            helpers.applySortOption(event.target.dataset.value);
          };

          return html`
            <pop-menu>
              <div class="disclosure disclosure--compact disclosure--auto-width disclosure--pop-down caption">
                <button
                  type="button"
                  class="disclosure__button localization-form__select localization-selector link link--text caption-large"
                  aria-expanded="false"
                  aria-controls="ListId"
                  aria-describedby="ListLabel"
                >
                  ${appliedSortOption.label}
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10">
                    <use href="#icon-caret" />
                  </svg>
                </button>
                <div class="disclosure__list-wrapper" hidden>
                  <ul id="ListId" role="list" class="scrollbar disclosure__list">
                    ${sortOptions.map((sortOption) => {
                      return html`
                        <li class="disclosure__item" tabindex="-1">
                          <a
                            class="disclosure__link focus-inset${sortOption.id === appliedSortOption.id
                              ? ` disclosure__link--active`
                              : null}"
                            onclick=${applySortOption}
                            data-value="${sortOption.id}"
                            href="?q=${helpers.getQuery()}&sort=${sortOption.id}"
                          >
                            ${sortOption.id === appliedSortOption.id
                              ? html`<svg
                                  aria-hidden="true"
                                  focusable="false"
                                  class="icon icon-caret"
                                  width="8"
                                  height="10"
                                >
                                  <use href="#icon-caret" />
                                </svg>`
                              : null}
                            ${sortOption.label}
                          </a>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              </div>
            </pop-menu>
          `;
        },
      },
      products: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var products = helpers.getProducts();

          return html`
          <ul
              id="product-grid"
              class="grid product-grid grid--large-up-gapless grid--2-col-tablet-down grid--4-col-desktop"
            >
              ${products.map(
                (product, index) =>
                  html`<li id="prod_li_${product.handle}" class="grid__item"><${args.templates.product} key=${product.id} product=${product} /></li>`
              )}
            </ul>
          `;
        },
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var product = props.product;
          return getCardMarkup(html, helpers, product, 'search-results');
        },
      },
      productListFooter: {
        render: function (html, args) {
          return html`
            <div id="product-grid-pagination" class="products-list-footer">
              <${args.templates.pagination} />
            </div>
          `;
        },
      },
      pagination: {
        options: {
          infiniteScroll: window.pagination.pagination_style == "ajax" || window.pagination.pagination_style == "both",
          paginationStyle: window.pagination.pagination_style,
          trackPageNumbersForInfiniteScroll: true,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          if (props.paginationStyle == 'ajax') {
            // if (helpers.canLoadMoreResults(props.showLoadMoreAfterEvery)) {
            return html`<${args.templates.loadMore} />`;
            // }
            // return null;
          }
          else if (props.paginationStyle == 'anchors') {
            return html`<${args.templates.paginationLinks} />`;
          }
          return html`<${args.templates.paginationLinks} />`;
        },
      },
      loadMore: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
          var currentPage = helpers.getCurrentPage();
          var products = args.props.helpers.getProducts();
          var totalProductsCount = parseInt(args.props.helpers.getTotalProductsCount());
          var totalProductsSeen = products.length;
          return html`
            ${helpers.hasNextPage
              ? html`
                  <div class="pagination-wrapper" id="product-grid-pagination">
                    <nav class="pagination" role="navigation" aria-label="Pagination">
                      <p class="pagination__status caption">
                        You've viewed ${totalProductsSeen} of ${totalProductsCount} products
                      </p>
                      ${totalProductsSeen !== totalProductsCount
                        ? html`
                            <button
                              onclick=${props.helpers.loadNextPage}
                              class="pagination__load-button search-load-more button button--tertiary scroll-trigger scroll-trigger--onscreen js"
                              ${!helpers.hasNextPage ? 'disabled' : null}
                              onclick=${helpers.hasNextPage ? helpers.goToNextPage : undefined}
                            >
                              <span>
                                <span>
                                  <span
                                    >${helpers.isLoading()
                                      ? labels.pagination.loading
                                      : labels.pagination.loadMore}</span
                                  >
                                  <span
                                    >${helpers.isLoading()
                                      ? labels.pagination.loading
                                      : labels.pagination.loadMore}</span
                                  >
                                </span>
                              </span>
                            </button>
                          `
                        : null}
                    </nav>
                  </div>
                `
              : null}
          `;
        },
      },
      paginationLinks: {
        options: {
          showNumberedPageLinks: true,
          numberedPageLinksWindowSize: 3,
          showPreviousPageLink: true,
          showFirstPageLink: true,
          showNextPageLink: true,
          scrollTop: true,
          paginationStyle: window.pagination.pagination_style,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
          var pagesToDisplay = helpers.getPagesToDisplay(props.numberedPageLinksWindowSize);
          var currentPage = helpers.getCurrentPage();
          var hasPreviousPage = helpers.hasPreviousPage();
          var hasNextPage = helpers.hasNextPage();
      
          var products = args.props.helpers.getProducts();
          var totalProductsCount = args.props.helpers.getTotalProductsCount();
          var totalProductsSeen = 16*currentPage;
      
          const getUrlWithPage = (page) => {
            const url = new URL(window.location.href);
            if(page <= 1) {
              url.searchParams.delete('page');
            }
            else {
              url.searchParams.set('page', page);
            }
            return url.toString();
          };
      
          return html`
          <div id="product-grid-pagination">
            ${props.showNextPageLink
              ? html`
                  <div class="pagination-wrapper tagalys-search">
                    <nav class="pagination" role="navigation" aria-label="Pagination">
                      <p class="pagination__status caption">
                        You've viewed ${totalProductsSeen} of ${totalProductsCount} products
                      </p>
                      ${ props.paginationStyle != 'anchors' && hasNextPage ? 
                       html`<button
                        onclick=${props.helpers.loadNextPage}
                        class="pagination__load-button search-load-more button button--tertiary scroll-trigger scroll-trigger--onscreen js"
                        ${!hasNextPage ? 'disabled' : null}
                      >
                        <span>
                          <span>
                            <span>Load more</span>
                            <span>Load more</span>
                          </span>
                        </span>
                      </button>` : null }
                      <div class="pagination__load-status" hidden>
                        <p class="infinite-scroll-request link-button-caps">Loading…</p>
                      </div>
                    </nav>
                  </div>
                `
              : null}
            <div class="pagination-wrapper tagalys-pagination-links">
              <nav class="pagination" role="navigation">
                <ul class="pagination__list list-unstyled" role="list">
                  ${props.showPreviousPageLink && hasPreviousPage
                    ? html`
                        <li>
                          <a
                            href="${getUrlWithPage(currentPage - 1)}"
                            class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                          >
                            <span class="visually-hidden">${labels.pagination.previousPage}</span>
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              class="icon icon-caret"
                              width="8"
                              height="10"
                              viewBox="0 0 8 10"
                              fill="none"
                            >
                              <path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path>
                            </svg>
                          </a>
                        </li>
                      `
                    : null}
                  ${props.showNumberedPageLinks
                    ? pagesToDisplay.map((pageDetail) => {
                        var classes = ['pagination__item', 'link'];
                        if (pageDetail.current) classes.push('active');
                        if (pageDetail.jumpAfter) classes.push('page-jump-over');
                        var className = classes.join(' ');
                        return html`
                          <li>
                            <a
                              href="${getUrlWithPage(pageDetail.page)}"
                              class="${className}"
                              aria-current=${pageDetail.current ? 'page' : undefined}
                            >
                              ${pageDetail.jumpAfter ? '...' : pageDetail.page}
                            </a>
                          </li>
                        `;
                      })
                    : null}
                  ${props.showNextPageLink && hasNextPage
                    ? html`
                        <li>
                          <a
                            href="${getUrlWithPage(currentPage + 1)}"
                            class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                          >
                            <span class="visually-hidden">${labels.pagination.nextPage}</span>
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              class="icon icon-caret"
                              width="8"
                              height="10"
                              viewBox="0 0 8 10"
                              fill="none"
                            >
                              <path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path>
                            </svg>
                          </a>
                        </li>
                      `
                    : null}
                </ul>
              </nav>
            </div>
            </div>
          `;
        },
      },
    },
  });
};
